import { render, staticRenderFns } from "./table.vue?vue&type=template&id=f13d84fc&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=f13d84fc&prod&lang=less&scoped=true"
import style1 from "./table.vue?vue&type=style&index=1&id=f13d84fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13d84fc",
  null
  
)

export default component.exports